// i18n.js - simple i18n implementation
const translations = {
  en: {
    showAll: "Show All",
    kebab: "Kebab",
    pizza: "Pizza",
    others: "Others",
    medium: "Medium",
    large: "Large",
    menu: "Menu",
    // Add more translations as needed
  },
  pt: {
    showAll: "Mostrar Tudo",
    kebab: "Kebab",
    pizza: "Pizza",
    others: "Outros",
    medium: "Media",
    large: "Grande",
    menu: "Menu",
    // Add more translations as needed
  },
};

export function t(lang, key) {
  return translations[lang]?.[key] || key;
}
